import { ForemanCrewAssignment } from './foreman-crew-assignment.model';
import { ForemanEquipmentUsage } from './foreman-equipment-usage.model';
import { ForemanEquipment } from './foreman-equipment.model';

export interface ForemanEquipmentDispatch {
  foremanEquipmentDispatchID: string;
  equipmentDispatchID?: string;
  foremanEquipmentID?: string;
  equipment: string;
  altID: string | null;
  dispatchStatus: string;
  foremanPhaseID: string;
  foremanPhaseName: string;
  foremanPhaseIDs?: string[];
  foremanPhaseNames?: string[];
  startDate: Date;
  endDate: Date;
  shift: number;
  shiftName: string;
  usages: ForemanEquipmentUsage[];
  totalHoursUsed: number;
  foremanEquipment: ForemanEquipment;
  foremanCrews?: ForemanCrewAssignment[];
  isSelectedForemanCrewEquipment?: boolean;
  bActive?: boolean;
  lastDayOnSite?: Date | null;
  /**
   * Server-owned UTC instant the dispatch row was created/last changed
   * (`ForemanEquipmentJob.ModifiedDate`). The "recently dispatched" signal —
   * a real assignment event, unlike the scheduled `startDate`/`endDate`.
   */
  modifiedDate?: Date | string | null;
}
